module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-5-tablet-f59106b721b2ef20ba0e1cadb59f9b19.png";